// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "shimport" + ".legacy." + "68d7e07f43559659127d" + ".js";
};